import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, ElementRef, inject, signal, Signal, ViewChild } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TransformCmsUrlPipe } from '../../core/pipe/transform-cms-url-pipe';
import { RouterService } from '../../core/services/router.service';
import { CmsService } from '../../core/store/cms/cms.service';
import { CmsStore } from '../../core/store/cms/cms.store';
import { StatusmeldungArticle } from '../../core/store/cms/cms.types';
import { RestUserService } from '../../rest/user.service';
import { ImportantMessageComponent } from '../../shared/building-blocks/important-message/important-message.component';
import { ImportantMessageService } from '../../shared/building-blocks/important-message/important-message.service';
import { NavbarComponent } from '../../shared/building-blocks/navbar/navbar.component';
import {KoalButtonComponent} from '../../shared/building-blocks/koal-button/koal-button.component';
import {BurgerMenuComponent} from './burger-menu/burger-menu.component';

@Component({
  selector:        'app-login-shell',
  templateUrl:     './login-shell.component.html',
  imports: [
    RouterModule,
    NgStyle,
    TransformCmsUrlPipe,
    NavbarComponent,
    ImportantMessageComponent,
    BurgerMenuComponent,
  ],
  styleUrls:       ['./login-shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginShellComponent  {

  public cmsService = inject(CmsService)
  public routerService = inject(RouterService)
  public currentBackURL: Signal<string> = signal(null);
  public router = inject(Router)
  public route = inject(ActivatedRoute)
  private importantMessageService = inject(ImportantMessageService)
  cmsStore = inject(CmsStore)

  public statusMeldung: StatusmeldungArticle =  this.cmsStore.currentCmsData()?.statusMeldung;
  userService = inject(RestUserService);

  @ViewChild('toggle') toggleRef: ElementRef;
  @ViewChild('toggleMobile') toggleMobileRef: ElementRef;

  constructor() {
    const onNavigationEnd = toSignal(this.router.events.pipe(filter(event => event instanceof NavigationEnd)));
    this.currentBackURL = computed(() => {
      if (onNavigationEnd()) {
        if (window.history.state?.overrideBackUrl) { // Custom History backUrl has priority
          return window.history.state.overrideBackUrl;
        }
        return this.route.firstChild && this.route.firstChild.snapshot.data ? (this.route.firstChild.snapshot.data as any).backButtonURL : null;
      }
      return null;
    });
    this.importantMessageService.message.next(this.statusMeldung?.acf?.content);
  }
}
